import generalPageLoadingActionTypes from "../action-types/generalPageLoadingActionTypes";
const { SET_PAGE_LOADING } = generalPageLoadingActionTypes;

export const setPageLoading = (state) => {
  return {
    type: SET_PAGE_LOADING,
    payload: state,
  };
};
